import RatioIcon11 from '../../assets/svg/1-1.svg?react';
import RatioIcon916 from '../../assets/svg/9-16.svg?react';
import RatioIcon169 from '../../assets/svg/16-9.svg?react';
import RatioIcon23 from '../../assets/svg/2-3.svg?react';
import RatioIcon32 from '../../assets/svg/3-2.svg?react';
import RatioIcon45 from '../../assets/svg/4-5.svg?react';
import RatioIcon54 from '../../assets/svg/5-4.svg?react';
import RatioIcon43 from '../../assets/svg/4-3.svg?react';
import RatioIcon34 from '../../assets/svg/3-4.svg?react';
import RatioIcon219 from '../../assets/svg/21-9.svg?react';
import RatioIconAuto from '../../assets/svg/auto.svg?react';
import RatioIcon921 from '../../assets/svg/9-21.svg?react';
import FJAiTextToVideoIcon from '../../assets/svg/menu/text-to-video.svg?react';
import FJAiTextToVideoActiveIcon from '../../assets/svg/menu/text-to-video-active.svg?react';
import FJAiImageToVideoIcon from '../../assets/svg/menu/image-to-video.svg?react';
import FJAiImageToVideoActiveIcon from '../../assets/svg/menu/image-to-video-active.svg?react';
import FJAiEffectsToVideoIcon from '../../assets/svg/menu/video-effects.svg?react';
import FJAiEffectsToVideoActiveIcon from '../../assets/svg/menu/video-effects-active.svg?react';
import FJFastIcon from '../../assets/svg/standard02.svg?react';
import FJProIcon from '../../assets/svg/pro02.svg?react';
import FJUltraIcon from '../../assets/svg/ultra02.svg?react';
// import FJHunyuanIcon from '../../assets/svg/hunyuan.svg?react';
import FJMaxMineIcon from '../../assets/svg/maxmine.svg?react';
import FJGoogleIcon from '../../assets/svg/google.svg?react';
import FJSoraIcon from '../../assets/svg/sora.svg?react';
import FJKlingIcon from '../../assets/svg/keling.svg?react';
import { CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES } from './FJGenerateData';
import FJAIVideoGeneratorConfig from '../appConfig/FJAIVideoGeneratorConfig';
import FJConfig from '../FJConfig';
import { TAGS, CATEGORIES } from '../../constants/FJModelAttributesConstant';

export const UPLOAD_IMG_TO_VIDEO_EFFECT =
    'image/png,image/jpg,image/jpeg,image/jfif,image/webp,image/bmp,image/tiff' +
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES;
export const UPLOAD_VIDEO_TO_VIDEO_EFFECT = 'video/mp4,video/mov,video/avi';
const FJAIVideoGeneratorData = {
    RATIO_LIST: [
        {
            name: '16:9',
            value: 16 / 9,
            icon: RatioIcon169,
        },
        {
            name: '9:16',
            value: 9 / 16,
            icon: RatioIcon916,
        },
        {
            name: '1:1',
            value: 1,
            icon: RatioIcon11,
        },
    ],
    DURATION_LIST: [
        {
            name: '5s',
            value: 5,
        },
        {
            name: '10s',
            value: 10,
        },
    ],
    QUALITY_LIST: [
        {
            name: 'standard',
            value: 1,
        },
        {
            name: 'professional',
            value: 2,
        },
    ],
    PROMPT_TEXT_LIMIT: 500,
    PROMPT_PLACEHOLDER: '',
};
export const AI_GENERATOR_VIDEO_TAB_TYPE = {
    AI_IMAGE_TO_VIDEO: 'ai-image-to-video', // 原来是数值1
    AI_TEXT_TO_VIDEO: 'ai-text-to-video', // 原来是数值 0
    AI_EFFECTS_VIDEO: 'ai-effects-video',
};
export const AI_GENERATOR_VIDEO_TAB_LIST = [
    {
        name: 'image-to-video',
        value: AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO,
        icon: FJAiImageToVideoIcon,
        hoverIcon: FJAiImageToVideoActiveIcon,
    },
    {
        name: 'text-to-video',
        value: AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO,
        icon: FJAiTextToVideoIcon,
        hoverIcon: FJAiTextToVideoActiveIcon,
    },
    {
        name: 'ai-video-effect',
        value: AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO,
        icon: FJAiEffectsToVideoIcon,
        hoverIcon: FJAiEffectsToVideoActiveIcon,
    },
];
export const AI_EFFECTS_TYPES = {
    ONE_PIC: 'one-pic',
    ONE_PIC_AND_PROMPTS: 'one-pic-and-prompts',
    TWO_OR_ONE_PIC: 'two-or-one-pic',
    TWO_PIC: 'two-pic',
    VIDEO_AND_PIC: 'video-and-pic',
};

// 图片上传模式
export const IMAGE_UPLOAD_MODES = {
    SINGLE: 'single', // 单图模式
    START_END: 'start-end', // 首尾帧模式
    MULTI: 'multi', // 多图模式
};

// 模型名称到值的映射
export const MODEL_VALUE_MAP = {
    STANDARD: 'flexclip',
    PRO_I2V: 'doubao-seedance-1-0-lite-i2v-250428',
    PRO_T2V: 'doubao-seedance-1-0-lite-t2v-250428',
    ULTRA: 'doubao-seedance-1-0-pro-fast-251015',
    SEEDANCE_15_PRO: 'doubao-seedance-1-5-pro-251215',
    MINIMAX_02: 'minimax-02',
    MINIMAX_23: 'minimax-2.3',
    MINIMAX_23_FAST: 'minimax-2.3-fast',
    MINIMAX_01: 'minimax-01',
    MINIMAX_01_LIVE: 'minimax-01-live',
    MINIMAX_01_DIRECTOR: 'minimax-01-director',
    GOOGLE_VEO_3: 'google-veo-3',
    GOOGLE_VEO_3_FAST: 'google-veo-3-fast',
    GOOGLE_VEO_2: 'google-veo-2',
    GOOGLE_VEO_31: 'google-veo-3.1',
    GOOGLE_VEO_31_FAST: 'google-veo-3.1-fast',
    GOOGLE_VEO_31_SUBJECT_REFERENCE: 'google-veo-3.1-subject-reference',
    KLING_V21_MASTER: 'kling-v2.1-master',
    KLING_V21: 'kling-v2.1',
    KLING_16_PRO: 'kling-1.6-pro',
    KLING_16_STANDARD: 'kling-1.6-standard',
    KLING_V20: 'kling-v2.0',
    KLING_16_PRO_SUBJECT: 'kling-1.6-pro-subject-reference',
    KLING_16_STANDARD_SUBJECT: 'kling-1.6-standard-subject-reference',
    KLING_V25_TURBO_PRO: 'kling-v2.5-turbo-pro',
    KLING_V26_TV: 'kling-v2.6-tv',
    KLING_V26_IV: 'kling-v2.6-iv',
    KLING_V26_MOTION_CONTROL: 'kling-motion-control',
    KLING_O1: 'kling-vo1',
    TENCENT_HUNYUAN: 'tencent-hunyuan',
    OPENAI_SORA_2: 'openai-sora-2',
    OPENAI_SORA_2_PRO: 'openai-sora-2-pro',
};

export const IMAGE_TO_VIDEO_DROPDOWN_LIST = [
    MODEL_VALUE_MAP.STANDARD,
    MODEL_VALUE_MAP.PRO_I2V,
    MODEL_VALUE_MAP.ULTRA,
    // ----------------
    // 各个厂商主推
    MODEL_VALUE_MAP.KLING_V26_MOTION_CONTROL,
    MODEL_VALUE_MAP.OPENAI_SORA_2_PRO,
    MODEL_VALUE_MAP.GOOGLE_VEO_31,
    MODEL_VALUE_MAP.SEEDANCE_15_PRO,
    MODEL_VALUE_MAP.KLING_O1,
    MODEL_VALUE_MAP.KLING_V26_IV,
    MODEL_VALUE_MAP.MINIMAX_23,
    // sora
    MODEL_VALUE_MAP.OPENAI_SORA_2,
    // Google Veo
    MODEL_VALUE_MAP.GOOGLE_VEO_31_FAST,
    MODEL_VALUE_MAP.GOOGLE_VEO_31_SUBJECT_REFERENCE,
    MODEL_VALUE_MAP.GOOGLE_VEO_3,
    MODEL_VALUE_MAP.GOOGLE_VEO_3_FAST,
    // kling
    MODEL_VALUE_MAP.KLING_16_PRO,
    MODEL_VALUE_MAP.KLING_V25_TURBO_PRO,
    MODEL_VALUE_MAP.KLING_16_PRO_SUBJECT,
    MODEL_VALUE_MAP.KLING_V21_MASTER,
    MODEL_VALUE_MAP.KLING_V21,
    // Minimax
    MODEL_VALUE_MAP.MINIMAX_02,
    MODEL_VALUE_MAP.MINIMAX_23_FAST,
    MODEL_VALUE_MAP.MINIMAX_01_DIRECTOR,
];
export const TEXT_TO_VIDEO_DROPDOWN_LIST = [
    MODEL_VALUE_MAP.STANDARD,
    MODEL_VALUE_MAP.PRO_T2V,
    MODEL_VALUE_MAP.ULTRA,
    // ----------------
    // 各个厂商主推
    MODEL_VALUE_MAP.OPENAI_SORA_2_PRO,
    MODEL_VALUE_MAP.GOOGLE_VEO_31_FAST,
    MODEL_VALUE_MAP.SEEDANCE_15_PRO,
    MODEL_VALUE_MAP.KLING_V26_TV,
    MODEL_VALUE_MAP.MINIMAX_23,
    // sora
    MODEL_VALUE_MAP.OPENAI_SORA_2,
    // Google Veo
    MODEL_VALUE_MAP.GOOGLE_VEO_3,
    MODEL_VALUE_MAP.GOOGLE_VEO_31,
    MODEL_VALUE_MAP.GOOGLE_VEO_3_FAST,
    // kling
    MODEL_VALUE_MAP.KLING_V25_TURBO_PRO,
    MODEL_VALUE_MAP.KLING_V21_MASTER,
    MODEL_VALUE_MAP.KLING_16_STANDARD,
    // Minimax
    MODEL_VALUE_MAP.MINIMAX_02,
    MODEL_VALUE_MAP.MINIMAX_01_DIRECTOR,
];

// 文本生成视频模型过滤器
export const TEXT_TO_VIDEO_MODEL_FILTERS = [
    { label: 'all', value: CATEGORIES.ALL },
    { label: '720p', value: CATEGORIES.P720 },
    { label: '1080p', value: CATEGORIES.P1080 },
    { label: 'dubbing', value: CATEGORIES.AUDIO },
];

// 图片生成视频模型过滤器
export const IMAGE_TO_VIDEO_MODEL_FILTERS = [
    { label: 'all', value: CATEGORIES.ALL },
    { label: '720p', value: CATEGORIES.P720 },
    { label: '1080p', value: CATEGORIES.P1080 },
    { label: 'keyframes', value: CATEGORIES.KEYFRAMES },
    { label: 'shots', value: CATEGORIES.SHOTS },
    { label: 'dubbing', value: CATEGORIES.AUDIO },
];

// 模型列表
export const AI_VIDEO_GENERATION_MODEL_LIST = [
    {
        name: 'standard',
        value: MODEL_VALUE_MAP.STANDARD,
        description: 'naturally-generate-realistic-scenes-and-people-from-text-and-image',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'standard.png' + `?v=${FJConfig.version}`,
        icon: FJFastIcon,
        imageUrl: 'standard.png', // 封面图url
        videoUrl: 'standard.mp4', // 视频url
        mode: IMAGE_UPLOAD_MODES.SINGLE, // 图片上传模式
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO], // 支持的tab类型
        supportImageSelectRatio: false,
        promptRequired: false, // prompt是否必填
        sfxSupported: true, // 是否支持音效
        creditPrice: 2, // 2积分/s
        promptCharacterLimit: 5000,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
        ],
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
            { name: '2:3', value: '2:3', icon: RatioIcon23 },
            { name: '3:2', value: '3:2', icon: RatioIcon32 },
            { name: '4:5', value: '4:5', icon: RatioIcon45 },
            { name: '5:4', value: '5:4', icon: RatioIcon54 },
            { name: '3:4', value: '3:4', icon: RatioIcon34 },
            { name: '4:3', value: '4:3', icon: RatioIcon43 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P720],
            'ai-text-to-video': [CATEGORIES.P720],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P720],
            'ai-text-to-video': [TAGS.P720, TAGS.FAST],
        },
    },
    {
        name: 'pro',
        value: MODEL_VALUE_MAP.PRO_I2V,
        description: 'support-start-and-end-frames-designed-for-short-videos',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'pro.png' + `?v=${FJConfig.version}`,
        icon: FJProIcon,
        imageUrl: 'pro.png',
        videoUrl: 'pro.mp4',
        mode: IMAGE_UPLOAD_MODES.START_END,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
        supportImageSelectRatio: false,
        promptRequired: false,
        sfxSupported: true,
        creditPrice: 4, // 7积分/s
        promptCharacterLimit: 5000,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
            // { name: '12s', value: 12 },
        ],
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
            { name: '4:3', value: '4:3', icon: RatioIcon43 },
            { name: '3:4', value: '3:4', icon: RatioIcon34 },
            { name: '21:9', value: '21:9', icon: RatioIcon219 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P720, CATEGORIES.KEYFRAMES],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P720, TAGS.KEYFRAMES],
        },
    },
    {
        name: 'pro',
        value: MODEL_VALUE_MAP.PRO_T2V,
        description: 'support-start-and-end-frames-designed-for-short-videos',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'pro.png' + `?v=${FJConfig.version}`,
        icon: FJProIcon,
        imageUrl: 'pro.png',
        videoUrl: 'pro.mp4',
        mode: IMAGE_UPLOAD_MODES.START_END,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        promptRequired: false,
        sfxSupported: true,
        creditPrice: 4, // 7积分/s
        promptCharacterLimit: 5000,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
            // { name: '12s', value: 12 },
        ],
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
            { name: '4:3', value: '4:3', icon: RatioIcon43 },
            { name: '3:4', value: '3:4', icon: RatioIcon34 },
            { name: '21:9', value: '21:9', icon: RatioIcon219 },
        ],
        categoryByMode: {
            'ai-text-to-video': [CATEGORIES.P720],
        },
        tagsByMode: {
            'ai-text-to-video': [CATEGORIES.P720],
        },
    },
    {
        name: 'ultra',
        value: MODEL_VALUE_MAP.ULTRA,
        description: 'multi-style-1080p-video-generation-with-camera-motion',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'ulitra.png' + `?v=${FJConfig.version}`,
        icon: FJUltraIcon,
        imageUrl: 'ultra.png',
        videoUrl: 'ultra.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE, // ultra 不支持 start-end 模式
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        promptRequired: false,
        sfxSupported: true,
        creditPrice: 5, // 12积分/s
        promptCharacterLimit: 5000,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
            // { name: '12s', value: 12 },
        ],
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
            { name: '4:3', value: '4:3', icon: RatioIcon43 },
            { name: '3:4', value: '3:4', icon: RatioIcon34 },
            { name: '21:9', value: '21:9', icon: RatioIcon219 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.SHOTS],
            'ai-text-to-video': [CATEGORIES.P1080],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.SHOTS],
            'ai-text-to-video': [TAGS.P1080, TAGS.SHOTS],
        },
    },
    // ---------------------------分组分割---------------------------------

    {
        name: 'Bytedance Seedance 1.5 Pro',
        value: MODEL_VALUE_MAP.SEEDANCE_15_PRO,
        description: 'seedance-1.5-pro-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'byte.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'byte.png' + `?v=${FJConfig.version}`,
        icon: FJProIcon,
        imageUrl: 'byte-1.5-pro.png',
        videoUrl: 'byte-1.5-pro.mp4',
        mode: IMAGE_UPLOAD_MODES.START_END,
        promptCharacterLimit: 2000,
        durations: [
            { name: '5s', value: 5 },
            { name: '8s', value: 8 },
            { name: '12s', value: 12 },
        ],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: true,
        sfxTitle: 'audio',
        hideSfxDesc: true,
        isNew: true,
        creditPrice: 3, // 3积分/s
        creditPriceWidThAudio: 5, // 3积分/s
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '4:3', value: '4:3', icon: RatioIcon43 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
            { name: '3:4', value: '3:4', icon: RatioIcon34 },
            { name: '21:9', value: '21:9', icon: RatioIcon219 },
            { name: '9:21', value: '9:21', icon: RatioIcon921 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P720, CATEGORIES.KEYFRAMES, CATEGORIES.AUDIO, CATEGORIES.TEXT_PROMPT],
            'ai-text-to-video': [CATEGORIES.P720, CATEGORIES.AUDIO, CATEGORIES.TEXT_PROMPT],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P720, TAGS.KEYFRAMES, TAGS.AUDIO, TAGS.TEXT_PROMPT],
            'ai-text-to-video': [TAGS.P720, TAGS.AUDIO, TAGS.TEXT_PROMPT],
        },
    },
    // kling (可灵) 类型
    {
        name: 'OpenAI Sora 2',
        value: MODEL_VALUE_MAP.OPENAI_SORA_2,
        description: 'openai-sora-2-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'sora.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'sora.png' + `?v=${FJConfig.version}`,
        icon: FJSoraIcon,
        imageUrl: 'sora-2.png',
        videoUrl: 'sora-2.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: false,
        creditPrice: 7, // 10积分/s
        promptCharacterLimit: 5000,
        durations: [
            { name: '4s', value: 4 },
            { name: '8s', value: 8 },
            { name: '12s', value: 12 },
        ],
        // ratios: null,
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P720, CATEGORIES.AUDIO],
            'ai-text-to-video': [CATEGORIES.P720, CATEGORIES.AUDIO],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P720, TAGS.AUDIO],
            'ai-text-to-video': [TAGS.P720, TAGS.AUDIO],
        },
    },
    {
        name: 'OpenAI Sora 2 Pro',
        value: MODEL_VALUE_MAP.OPENAI_SORA_2_PRO,
        description: 'openai-sora-2-pro-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'sora.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'sora.png' + `?v=${FJConfig.version}`,
        icon: FJSoraIcon,
        imageUrl: 'sora-2-pro.png',
        videoUrl: 'sora-2-pro.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: false,
        creditPrice: 23, // 积分/s
        promptCharacterLimit: 5000,
        creditPriceLevels: {
            '720p': 30,
            '1080p': 40,
        },
        resolutions: [
            { name: '720p', value: '720p' },
            { name: '1080p', value: '1080p' },
        ],
        durations: [
            { name: '4s', value: 4 },
            { name: '8s', value: 8 },
            { name: '12s', value: 12 },
        ],
        // ratios: null,
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P720, CATEGORIES.P1080, CATEGORIES.AUDIO],
            'ai-text-to-video': [CATEGORIES.P720, CATEGORIES.P1080, CATEGORIES.AUDIO],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.AUDIO, TAGS.TEXT_PROMPT],
            'ai-text-to-video': [TAGS.P1080, TAGS.AUDIO, TAGS.TEXT_PROMPT],
        },
    },
    {
        name: 'Kling 1.6 Standard',
        value: MODEL_VALUE_MAP.KLING_16_STANDARD,
        description: 'combining-stability-and-efficiency-to-empower-video-creation',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        icon: FJKlingIcon,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        imageUrl: 'kling1.6-standard.png',
        videoUrl: 'kling1.6-standard.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
        ],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: true,
        sfxSupported: true,
        creditPrice: 5, // 12积分/s
        promptCharacterLimit: 2500,
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
        ],
        categoryByMode: {
            'ai-text-to-video': [CATEGORIES.P720],
        },
        tagsByMode: {
            'ai-text-to-video': [CATEGORIES.P720],
        },
    },
    // {
    //     name: 'kling 1.6 Standard Subject Reference',
    //     value: MODEL_VALUE_MAP.KLING_16_STANDARD_SUBJECT,
    //     description: 'generate-desired-videos-from-multiple-images',
    //     icon: FJKlingIcon,
    //     imageUrl: 'car.png',
    //     videoUrl: 'car.mp4',
    //     mode: IMAGE_UPLOAD_MODES.MULTI,
    //     supportImageSelectRatio: true,
    //     durations: [
    //         { name: '5s', value: 5 },
    //         { name: '10s', value: 10 },
    //     ],
    //     promptRequired: true,
    //     supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
    // supportImageSelectRatio:false,
    // sfxSupported: true,
    //     creditPrice: 12, // 12积分/s
    //     ratios: [
    //         { name: '16:9', value: '16:9', icon: RatioIcon169 },
    //         { name: '9:16', value: '9:16', icon: RatioIcon916 },
    //         { name: '1:1', value: '1:1', icon: RatioIcon11 },
    //     ],
    // },
    {
        name: 'Kling 1.6 PRO',
        value: MODEL_VALUE_MAP.KLING_16_PRO,
        description: 'support-start-end-frames-and-1080p-output',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        icon: FJKlingIcon,
        imageUrl: 'kling-v1.6-pro.png',
        videoUrl: 'kling-v1.6-pro.mp4',
        mode: IMAGE_UPLOAD_MODES.START_END,
        promptCharacterLimit: 2500,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
        ],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: true,
        creditPrice: 10, // 16积分/s
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.KEYFRAMES],
        },
        tagsByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.KEYFRAMES],
        },
    },
    {
        name: 'Kling 1.6 PRO Subject Reference',
        value: MODEL_VALUE_MAP.KLING_16_PRO_SUBJECT,
        description: 'generate-consistent-character-or-object-videos-from-multiple-reference-images',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        icon: FJKlingIcon,
        imageUrl: 'kling-v1.6-standard.png',
        videoUrl: 'kling-v1.6-standard.mp4',
        mode: IMAGE_UPLOAD_MODES.MULTI,
        supportReferenceImages: 4,
        promptCharacterLimit: 2500,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
        ],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
        supportImageSelectRatio: true,
        sfxSupported: true,
        creditPrice: 10, // 16积分/s
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.REFERENCE],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.REFERENCE],
        },
    },
    // {
    //     name: 'kling 2.0',
    //     value: MODEL_VALUE_MAP.KLING_V20,
    //     description: 'high-quality-rendering-and-cinematic-shot-expression',
    //     icon: FJKlingIcon,
    //     imageUrl: 'car.png',
    //     videoUrl: 'car.mp4',
    //     mode: IMAGE_UPLOAD_MODES.SINGLE,
    //     durations: [
    //         { name: '5s', value: 5 },
    //         { name: '10s', value: 10 },
    //     ],
    //     promptRequired: true,
    //     supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
    // supportImageSelectRatio:false,
    // sfxSupported: true,
    //     creditPrice: 20, // 20积分/s
    //     ratios: [
    //         { name: '16:9', value: '16:9', icon: RatioIcon169 },
    //         { name: '9:16', value: '9:16', icon: RatioIcon916 },
    //         { name: '1:1', value: '1:1', icon: RatioIcon11 },
    //     ],
    // },
    {
        name: 'Kling 2.1',
        value: MODEL_VALUE_MAP.KLING_V21,
        description: 'great-value-perfect-for-large-scale-content-creation',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        icon: FJKlingIcon,
        imageUrl: 'kling-v2.1.png',
        videoUrl: 'kling-v2.1.mp4',
        mode: IMAGE_UPLOAD_MODES.START_END,
        promptCharacterLimit: 2500,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
        ],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: true,
        creditPrice: 9, // 20积分/s
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.KEYFRAMES],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.KEYFRAMES, TAGS.FAST],
        },
    },
    {
        name: 'Kling 2.1 Master',
        value: MODEL_VALUE_MAP.KLING_V21_MASTER,
        description: '1080p-output-with-cinematic-camera-control',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        icon: FJKlingIcon,
        imageUrl: 'kling-v2.1-Master.png',
        videoUrl: 'kling-v2.1-Master.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptCharacterLimit: 2500,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
        ],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: true,
        creditPrice: 20, // 30积分/s
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.SHOTS],
            'ai-text-to-video': [CATEGORIES.P1080],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.SHOTS],
            'ai-text-to-video': [TAGS.P1080, TAGS.SHOTS, TAGS.CINEMATIC],
        },
    },

    {
        name: 'Kling 2.5 Turbo',
        value: MODEL_VALUE_MAP.KLING_V25_TURBO_PRO,
        description: 'kling-v2.5-turbo-pro-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        icon: FJKlingIcon,
        imageUrl: 'kling-v2.5-turbo-pro.png',
        videoUrl: 'kling-v2.5-turbo-pro.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptCharacterLimit: 2500,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
        ],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: true,
        creditPrice: 8, // 30积分/s
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080],
            'ai-text-to-video': [CATEGORIES.P1080],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.CINEMATIC],
            'ai-text-to-video': [TAGS.P1080, TAGS.CINEMATIC],
        },
    },
    {
        name: 'Kling 2.6',
        value: MODEL_VALUE_MAP.KLING_V26_TV,
        description: 'kling-v2.6-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        icon: FJKlingIcon,
        // imageUrl: 'kling-v2.6.png',
        // videoUrl: 'kling-v2.6.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptCharacterLimit: 2500,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
        ],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: false,
        creditPrice: 10,
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
        ],
        isNew: true,
        categoryByMode: {
            'ai-text-to-video': [CATEGORIES.P1080],
        },
        tagsByMode: {
            'ai-text-to-video': [TAGS.P1080],
        },
    },
    {
        name: 'Kling 2.6',
        value: MODEL_VALUE_MAP.KLING_V26_IV,
        description: 'kling-v2.6-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        icon: FJKlingIcon,
        // imageUrl: 'kling-v2.6.png',
        // videoUrl: 'kling-v2.6.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptCharacterLimit: 2500,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
        ],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: false,
        creditPrice: 10,
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
        ],
        isNew: true,
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.AUDIO],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, CATEGORIES.AUDIO],
        },
    },
    {
        name: 'Kling 2.6 Motion-control',
        value: MODEL_VALUE_MAP.KLING_V26_MOTION_CONTROL,
        description: 'kling-2.6-motion-control-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        icon: FJKlingIcon,
        imageUrl: 'kling-2.6-motion-control.png',
        videoUrl: 'kling-2.6-motion-control.mp4',
        mode: IMAGE_UPLOAD_MODES.MULTI,
        promptCharacterLimit: 2500,
        promptRequired: false,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: false,
        hideSfxDesc: true,
        creditPrice: 6, // 6积分/s
        creditPriceLevels: {
            // 积分等级定价
            '720p': 6,
            '1080p': 8,
        },
        resolutions: [
            { name: '720p', value: '720p' },
            { name: '1080p', value: '1080p' },
        ],
        characterOrientation: [
            {
                name: 'video-recommend',
                value: 'video',
                outName: 'based-on-the-video',
                desc: 'preserves-reference-video-orientation-optimized-for-complex-motions-max-30s',
                maxDuration: 30,
            },
            {
                name: 'image',
                value: 'image',
                outName: 'based-on-the-image',
                desc: 'preserves-reference-image-orientation-optimized-for-camera-movements-max-10s',
                maxDuration: 10,
            },
        ],
        ratios: null,
        isNew: true,
        durations: null,
        customDurations: true,
        defaultMinDuration: 3,
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P720, CATEGORIES.P1080, CATEGORIES.AUDIO],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.AUDIO, TAGS.ACTIONS_PRECISION, TAGS.EXPRESSION_CONTROL],
        },
    },
    {
        name: 'Kling O1',
        value: MODEL_VALUE_MAP.KLING_O1,
        description: 'kling-o1-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        icon: FJKlingIcon,
        // imageUrl: 'kling-o1.png',
        // videoUrl: 'kling-o1.mp4',
        mode: IMAGE_UPLOAD_MODES.START_END,
        promptCharacterLimit: 2500,
        durations: [
            { name: '5s', value: 5 },
            { name: '10s', value: 10 },
        ],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: true,
        creditPrice: 9,
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
            { name: '1:1', value: '1:1', icon: RatioIcon11 },
        ],
        isNew: true,
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.KEYFRAMES],
        },
        tagsByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.KEYFRAMES],
        },
    },
    {
        name: 'Minimax Hailuo 2.3',
        value: MODEL_VALUE_MAP.MINIMAX_23,
        description: 'hailuo-2.3-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'hailuo.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'hailuo.png' + `?v=${FJConfig.version}`,
        icon: FJMaxMineIcon,
        imageUrl: 'hailuo-2.3.png',
        videoUrl: 'hailuo-2.3.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: true,
        creditPrice: 20, // 20积分/s
        promptCharacterLimit: 2000,
        creditPriceLevels: {
            // 积分等级定价
            '768p': 5,
            '1080p': 8,
        },
        resolutions: [
            { name: '768p', value: '768p', supportDurations: [6, 10] },
            { name: '1080p', value: '1080p', supportDurations: [6] },
        ],
        durations: [
            { name: '6s', value: 6 },
            { name: '10s', value: 10 },
        ],
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080],
            'ai-text-to-video': [CATEGORIES.P1080],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.ACTION_SMOOTH, TAGS.CINEMATIC],
            'ai-text-to-video': [TAGS.P768, TAGS.P1080, TAGS.ACTION_SMOOTH, TAGS.CINEMATIC],
        },
    },
    {
        name: 'Minimax Hailuo 2.3 Fast',
        value: MODEL_VALUE_MAP.MINIMAX_23_FAST,
        description: 'hailuo-2.3-fast-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'hailuo.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'hailuo.png' + `?v=${FJConfig.version}`,
        icon: FJMaxMineIcon,
        imageUrl: 'hailuo-2.3-fast.png',
        videoUrl: 'hailuo-2.3-fast.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: true,
        creditPrice: 15, // 15积分/s
        promptCharacterLimit: 2000,
        creditPriceLevels: {
            '768p': 3,
            '1080p': 6,
        },
        resolutions: [
            { name: '768p', value: '768p', supportDurations: [6, 10] },
            { name: '1080p', value: '1080p', supportDurations: [6] },
        ],
        durations: [
            { name: '6s', value: 6 },
            { name: '10s', value: 10 },
        ],
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P768, TAGS.P1080],
        },
    },
    // hunyuan（腾讯） 类型 TODO: 暂时不支持
    // {
    //     name: 'Tencent Hunyuan',
    //     value: MODEL_VALUE_MAP.TENCENT_HUNYUAN,
    //     description: 'support-video-generation-in-multiple-aspect-ratios',
    //     icon: FJHunyuanIcon,
    //     imageUrl: 'car.png',
    //     videoUrl: 'car.mp4',
    //     mode: IMAGE_UPLOAD_MODES.SINGLE,
    //     durations: [{ name: '5s', value: 5 }],
    //     promptRequired: true,
    //     supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
    // supportImageSelectRatio:false,
    // sfxSupported: true,
    //     creditPrice: 7, // 7积分/s
    //     ratios: [
    //         { name: '16:9', value: '16:9', icon: RatioIcon169 },
    //         { name: '9:16', value: '9:16', icon: RatioIcon916 },
    //         { name: '1:1', value: '1:1', icon: RatioIcon11 },
    //         { name: '3:4', value: '3:4', icon: RatioIcon34 },
    //         { name: '4:3', value: '4:3', icon: RatioIcon43 },
    //         { name: '21:9', value: '21:9', icon: RatioIcon219 },
    //     ],
    // },
    // minimax (海螺) 类型
    // {
    //     name: 'Minimax Hailuo 01',
    //     value: MODEL_VALUE_MAP.MINIMAX_01,
    //     description: 'generate-stable-coherent-short-videos-fast',
    //     icon: FJMaxMineIcon,
    //     imageUrl: 'car.png',
    //     videoUrl: 'car.mp4',
    //     mode: IMAGE_UPLOAD_MODES.SINGLE,
    //     promptRequired: true,
    //     supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
    // supportImageSelectRatio:false,
    // sfxSupported: true,
    //     creditPrice: 15, // 15积分/s
    //     durations: [{ name: '6s', value: 6 }],
    //     ratios: null,
    // },
    // {
    //     name: 'Minimax Hailuo 01-live',
    //     value: MODEL_VALUE_MAP.MINIMAX_01_LIVE,
    //     description: 'designed-for-dynamic-artworks-with-smooth-and-stable-effects',
    //     icon: FJMaxMineIcon,
    //     imageUrl: 'car.png',
    //     videoUrl: 'car.mp4',
    //     mode: IMAGE_UPLOAD_MODES.SINGLE,
    //     promptRequired: true,
    //     supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
    // supportImageSelectRatio:false,
    // sfxSupported: true,
    //     creditPrice: 18, // 18积分/s
    //     durations: [{ name: '5s', value: 5 }],
    //     ratios: null,
    // },
    {
        name: 'Minimax Hailuo 01-director',
        value: MODEL_VALUE_MAP.MINIMAX_01_DIRECTOR,
        description: 'pro-level-shot-control-and-cinematic-camera-moves',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'hailuo.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'hailuo.png' + `?v=${FJConfig.version}`,
        icon: FJMaxMineIcon,
        imageUrl: 'minimax-01-director.png',
        videoUrl: 'minimax-01-director.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptCharacterLimit: 2000,
        durations: [{ name: '6s', value: 6 }],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: true,
        creditPrice: 8, // 15积分/s
        ratios: null,
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P720, CATEGORIES.SHOTS],
            'ai-text-to-video': [CATEGORIES.P720],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P720, TAGS.SHOTS],
            'ai-text-to-video': [TAGS.P720, TAGS.SHOTS],
        },
    },
    {
        name: 'Minimax Hailuo 02',
        value: MODEL_VALUE_MAP.MINIMAX_02,
        description: 'strong-instruction-following-capability',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'hailuo.png' + `?v=${FJConfig.version}`,
        renderImageIcon: FJAIVideoGeneratorConfig.modelIconPath + 'hailuo.png' + `?v=${FJConfig.version}`,
        icon: FJMaxMineIcon,
        imageUrl: 'hailuo-02.png',
        videoUrl: 'hailuo-02.mp4',
        mode: IMAGE_UPLOAD_MODES.START_END,
        promptCharacterLimit: 2000,
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: true,
        creditPrice: 5, // 20积分/s
        durations: [
            { name: '6s', value: 6 },
            { name: '10s', value: 10 },
        ],
        ratios: null,
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P720, CATEGORIES.KEYFRAMES],
            'ai-text-to-video': [CATEGORIES.P720],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P768, TAGS.KEYFRAMES],
            'ai-text-to-video': [TAGS.P768, TAGS.TEXT_PROMPT],
        },
    },
    // veo (谷歌) 类型
    // {
    //     name: 'Google  Veo 2',
    //     value: MODEL_VALUE_MAP.GOOGLE_VEO_2,
    //     description: 'generate-highly-realistic-and-detailed-4k-scenes',
    //     icon: FJGoogleIcon,
    //     imageUrl: 'car.png',
    //     videoUrl: 'car.mp4',
    //     mode: IMAGE_UPLOAD_MODES.SINGLE,
    //     promptRequired: false,
    // supportImageSelectRatio: true,
    //     supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
    // supportImageSelectRatio:false,
    // sfxSupported: true,
    //     creditPrice: 40, // 40积分/s
    //     durations: [
    //         { name: '5s', value: 5 },
    //         { name: '8s', value: 8 },
    //     ],
    //     ratios: [
    //         { name: '16:9', value: '16:9', icon: RatioIcon169 },
    //         { name: '9:16', value: '9:16', icon: RatioIcon916 },
    //     ],
    // },

    {
        name: 'Google Veo 3.1',
        value: MODEL_VALUE_MAP.GOOGLE_VEO_31,
        description: 'google-veo-3.1-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
        icon: FJGoogleIcon,
        imageUrl: 'google-veo-3.1.png',
        videoUrl: 'google-veo-3.1.mp4',
        mode: IMAGE_UPLOAD_MODES.START_END,
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: true,
        sfxSupported: false,
        creditPrice: 23, // 37.5积分/s
        promptCharacterLimit: 5000,
        durations: [
            { name: '4s', value: 4 },
            { name: '6s', value: 6 },
            { name: '8s', value: 8 },
        ],
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.AUDIO, CATEGORIES.KEYFRAMES],
            'ai-text-to-video': [CATEGORIES.P1080, CATEGORIES.AUDIO],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.AUDIO, TAGS.KEYFRAMES, TAGS.TEXT_PROMPT],
            'ai-text-to-video': [TAGS.P1080, TAGS.AUDIO, TAGS.TEXT_PROMPT],
        },
    },
    {
        name: 'Google Veo 3.1 Fast',
        value: MODEL_VALUE_MAP.GOOGLE_VEO_31_FAST,
        description: 'google-veo-3.1-fast-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
        icon: FJGoogleIcon,
        imageUrl: 'google-veo-3.1-fast.png',
        videoUrl: 'google-veo-3.1-fast.mp4',
        mode: IMAGE_UPLOAD_MODES.START_END,
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: true,
        sfxSupported: false,
        creditPrice: 9, // 20积分/s
        promptCharacterLimit: 5000,
        durations: [
            { name: '4s', value: 4 },
            { name: '6s', value: 6 },
            { name: '8s', value: 8 },
        ],
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.AUDIO, CATEGORIES.KEYFRAMES],
            'ai-text-to-video': [CATEGORIES.P1080, CATEGORIES.AUDIO],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.AUDIO, TAGS.KEYFRAMES],
            'ai-text-to-video': [TAGS.P1080, TAGS.AUDIO],
        },
    },
    {
        name: 'Google Veo 3.1 Subject Reference',
        value: MODEL_VALUE_MAP.GOOGLE_VEO_31_SUBJECT_REFERENCE,
        description: 'google-veo-3.1-subject-reference-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
        icon: FJGoogleIcon,
        imageUrl: 'google-veo-3.1-subject-reference.png',
        videoUrl: 'google-veo-3.1-subject-reference.mp4',
        mode: IMAGE_UPLOAD_MODES.MULTI,
        supportReferenceImages: 3,
        promptCharacterLimit: 5000,
        durations: [{ name: '8s', value: 8 }],
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO],
        supportImageSelectRatio: false,
        sfxSupported: false,
        creditPrice: 23, // 37.5积分/s
        ratios: null,
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.AUDIO, CATEGORIES.REFERENCE],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.AUDIO, TAGS.REFERENCE],
        },
    },
    {
        name: 'Google Veo 3 Fast',
        value: MODEL_VALUE_MAP.GOOGLE_VEO_3_FAST,
        description: 'google-veo-3-fast-desc',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
        icon: FJGoogleIcon,
        imageUrl: 'google-veo-3-fast.png',
        videoUrl: 'google-veo-3-fast.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptCharacterLimit: 5000,
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: true,
        sfxSupported: false,
        creditPrice: 9, // 20积分/s
        durations: [
            { name: '4s', value: 4 },
            { name: '6s', value: 6 },
            { name: '8s', value: 8 },
        ],
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.AUDIO],
            'ai-text-to-video': [CATEGORIES.P1080, CATEGORIES.AUDIO],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.AUDIO, TAGS.FAST],
            'ai-text-to-video': [TAGS.P1080, TAGS.AUDIO, TAGS.FAST],
        },
    },
    {
        name: 'Google Veo 3',
        value: MODEL_VALUE_MAP.GOOGLE_VEO_3,
        description: 'auto-add-sfx-or-voiceovers-synced-with-visuals',
        renderIcon: FJAIVideoGeneratorConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
        icon: FJGoogleIcon,
        imageUrl: 'google-Veo-3.png',
        videoUrl: 'google-Veo-3.mp4',
        mode: IMAGE_UPLOAD_MODES.SINGLE,
        promptCharacterLimit: 5000,
        promptRequired: true,
        supportedModes: [AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO, AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO],
        supportImageSelectRatio: true,
        sfxSupported: false,
        creditPrice: 23, // 37积分/s
        durations: [
            { name: '4s', value: 4 },
            { name: '6s', value: 6 },
            { name: '8s', value: 8 },
        ],
        ratios: [
            { name: '16:9', value: '16:9', icon: RatioIcon169 },
            { name: '9:16', value: '9:16', icon: RatioIcon916 },
        ],
        categoryByMode: {
            'ai-image-to-video': [CATEGORIES.P1080, CATEGORIES.AUDIO],
            'ai-text-to-video': [CATEGORIES.P1080, CATEGORIES.AUDIO],
        },
        tagsByMode: {
            'ai-image-to-video': [TAGS.P1080, TAGS.AUDIO],
            'ai-text-to-video': [TAGS.P1080, TAGS.AUDIO],
        },
    },
];

// 每个模型对应的比例配置
export const MODEL_RATIO_MAP = {
    standard_v1: [
        {
            name: '16:9',
            value: '16:9',
            icon: RatioIcon169,
        },
        {
            name: '9:16',
            value: '9:16',
            icon: RatioIcon916,
        },
    ],
    'professional_v1.5': [
        {
            name: '16:9',
            value: '16:9',
            icon: RatioIcon169,
        },
        {
            name: '9:16',
            value: '9:16',
            icon: RatioIcon916,
        },
        {
            name: '1:1',
            value: 1,
            icon: RatioIcon11,
        },
    ],
    creative_v2: [
        {
            name: '16:9',
            value: '16:9',
            icon: RatioIcon169,
        },
        {
            name: '9:16',
            value: '9:16',
            icon: RatioIcon916,
        },
        {
            name: '1:1',
            value: 1,
            icon: RatioIcon11,
        },
    ],
};

// 每个模型对应的时长配置
export const MODEL_DURATION_MAP = {
    standard_v1: [
        {
            name: '5s',
            value: 5,
        },
    ],
    'professional_v1.5': [
        {
            name: '5s',
            value: 5,
        },
        {
            name: '10s',
            value: 10,
        },
    ],
    creative_v2: [
        {
            name: '5s',
            value: 5,
        },
        {
            name: '10s',
            value: 10,
        },
        {
            name: '15s',
            value: 15,
        },
    ],
};

// 获取指定模型的比例列表
export const getModelRatios = modelValue => {
    const model = AI_VIDEO_GENERATION_MODEL_LIST.find(item => item.value === modelValue);
    return model?.ratios || [];
};

// 获取指定模型的时长列表
export const getModelDurations = modelValue => {
    const model = AI_VIDEO_GENERATION_MODEL_LIST.find(item => item.value === modelValue);
    return model?.customDurations ? [{ value: model?.defaultMinDuration }] : model?.durations || [];
};

// 营销页面参数映射
export const VIDEO_GENERATOR_MARKETING_PARAMS_MAP = {
    standard: MODEL_VALUE_MAP.STANDARD,
    'pro-i2v': MODEL_VALUE_MAP.PRO_I2V,
    'pro-t2v': MODEL_VALUE_MAP.PRO_T2V,
    ultra: MODEL_VALUE_MAP.ULTRA,
    'minimax-02': MODEL_VALUE_MAP.MINIMAX_02,
    'minimax-01': MODEL_VALUE_MAP.MINIMAX_01,
    'minimax-01-live': MODEL_VALUE_MAP.MINIMAX_01_LIVE,
    'minimax-01-director': MODEL_VALUE_MAP.MINIMAX_01_DIRECTOR,
    'google-veo-3': MODEL_VALUE_MAP.GOOGLE_VEO_3,
    'google-veo-3.1': MODEL_VALUE_MAP.GOOGLE_VEO_31,
    'google-veo-3-voice': MODEL_VALUE_MAP.GOOGLE_VEO_3_FAST,
    'google-veo-2': MODEL_VALUE_MAP.GOOGLE_VEO_2,
    'kling-master': MODEL_VALUE_MAP.KLING_V21_MASTER,
    'kling-hd': MODEL_VALUE_MAP.KLING_V21,
    'kling-pro': MODEL_VALUE_MAP.KLING_16_PRO,
    'kling-standard': MODEL_VALUE_MAP.KLING_16_STANDARD,
    'kling-v2': MODEL_VALUE_MAP.KLING_V20,
    'kling-subject-reference': MODEL_VALUE_MAP.KLING_16_PRO_SUBJECT,
    'kling-standard-subject': MODEL_VALUE_MAP.KLING_16_STANDARD_SUBJECT,
    'tencent-hunyuan': MODEL_VALUE_MAP.TENCENT_HUNYUAN,
    'kling-v2.5-turbo-pro': MODEL_VALUE_MAP.KLING_V25_TURBO_PRO,
    'openai-sora-2': MODEL_VALUE_MAP.OPENAI_SORA_2,
    'openai-sora-2-pro': MODEL_VALUE_MAP.OPENAI_SORA_2_PRO,
    'google-veo-3.1-subject-reference': MODEL_VALUE_MAP.GOOGLE_VEO_31_SUBJECT_REFERENCE,
    'kling-vo1': MODEL_VALUE_MAP.KLING_O1,
    'minimax-2.3': MODEL_VALUE_MAP.MINIMAX_23,
    'minimax-2.3-fast': MODEL_VALUE_MAP.MINIMAX_23_FAST,
    'google-veo-3.1-fast': MODEL_VALUE_MAP.GOOGLE_VEO_31_FAST,
    'seedance-1.5-pro': MODEL_VALUE_MAP.SEEDANCE_15_PRO,
    'kling-2.6-motion-control': MODEL_VALUE_MAP.KLING_V26_MOTION_CONTROL,
};

export const LANDING_PAGE_MODEL_VALUE_MAP = {
    'hailuo-ai': MODEL_VALUE_MAP.MINIMAX_02,
    'veo-3': MODEL_VALUE_MAP.GOOGLE_VEO_3_FAST,
    'kling-ai': MODEL_VALUE_MAP.KLING_V25_TURBO_PRO,
    'sora-2': MODEL_VALUE_MAP.OPENAI_SORA_2,
};
export const MOTION_CONTROL_PRESET_LIST = [
    {
        id: 'dance',
        preImage: 'dance.png',
        previewVideo: 'dance.mp4',
    },
    {
        id: 'finger-dance',
        preImage: 'finger-dance.png',
        previewVideo: 'finger-dance.mp4',
    },
    {
        id: 'subject-three',
        preImage: 'subject-three.png',
        previewVideo: 'subject-three.mp4',
    },
    {
        id: 'expression-imitation',
        preImage: 'expression-imitation.png',
        previewVideo: 'expression-imitation.mp4',
    },

    {
        id: 'gossip',
        preImage: 'gossip.png',
        previewVideo: 'gossip.mp4',
    },
    {
        id: 'outfit-display',
        preImage: 'outfit-display.png',
        previewVideo: 'outfit-display.mp4',
    },
    {
        id: 'finger-dance2',
        preImage: 'finger-dance2.png',
        previewVideo: 'finger-dance2.mp4',
    },
];
export default FJAIVideoGeneratorData;
